
namespace TerminalApp {

    export class ItemSearchExtraData {
        purchaseOrderLineInfo: SP.PurchaseOrderLineInfo;
    }
    export class ItemSearcherAssistant {
        container = document.createElement("div");
        customer_menu = document.createElement("div");
        customer_suggestion_container = document.createElement("div");
        item_menu = document.createElement("div");
        item_suggestion_container = document.createElement("div");
        search_input = document.createElement("input");
        search_input_number = document.createElement("input");
        customerId: string;
        resultCount = 0;
        callback: (itemInfo: SP.ItemInfo, extraData: ItemSearchExtraData) => void;
        keyword: string;
        numberInput: boolean;
        constructor() {
            this.container.classList.add("assistant");

            //close button
            var close_button = this.container.appendChild(document.createElement("div"))
            close_button.classList.add("close");
            close_button.innerHTML = "X";
            close_button.addEventListener("click", () => {
                this.close();
            });

            //setup stock screen
            var customer_headline = this.customer_menu.appendChild(document.createElement("h1"));
            customer_headline.innerHTML = SP.Localize("sentance_select_stock");
            this.customer_menu.append(this.customer_suggestion_container);


            //setup item screen
            var headline = this.item_menu.appendChild(document.createElement("h1"));
            headline.innerHTML = SP.Localize("sentance_search_item");
            this.search_input.type = "text";
            this.search_input.placeholder = SP.Localize("sentance_search_item") + " ...";
            this.search_input.autocomplete = "off";
            this.search_input.tabIndex = 1;
            this.search_input.classList.add("search_input", "form-control");

            this.item_suggestion_container.classList.add("item_suggestion_container");

            this.search_input_number.type = "number";
            this.search_input_number.placeholder = SP.Localize("sentance_enter_barcode") + " ...";
            this.search_input_number.autocomplete = "off";
            this.search_input_number.tabIndex = 1;
            this.search_input_number.classList.add("search_input", "form-control");

            let to = null as any;

            this.search_input.addEventListener("keyup", () => {
                clearTimeout(to);
                to = setTimeout(() => {
                    this.search(this.search_input.value, false);
                }, 500);
            });

            this.search_input_number.addEventListener("keyup", () => {
                clearTimeout(to);
                to = setTimeout(() => {
                    this.search(this.search_input_number.value, false);
                }, 500);
            });

            this.item_menu.append(this.search_input);
            this.item_menu.append(this.search_input_number);
            this.item_menu.append(this.item_suggestion_container);
            this.container.appendChild(this.item_menu);
            this.container.appendChild(this.customer_menu);
        }

        hide() {
            this.item_menu.style.display = "none";
            this.customer_menu.style.display = "none";
        }

        async open_customer_picker() {
            this.hide();
            this.container.style.display = "block";
            this.customer_menu.style.display = "block";
            let customers = await SP.Data.Customer.getCustomerInfos();
            this.customer_suggestion_container.innerHTML = "";
            if (customers.length == 1) {
                this.customerId = customers[0].customerId;
                return this.open_product_picker();
            } 
            customers.forEach(customer => {
                this.addCustomer(customer);
            });
        }

        async open_product_picker() {

            if (this.keyword) {
                var autopicked = await this.search(this.keyword, true);
                console.log("autopicked:", autopicked);

                if (autopicked) return this.close();
            }

            this.search_input_number.style.display = this.numberInput ? "" : "none";
            this.search_input.style.display = this.numberInput ? "none" : "";

            if (this.numberInput) {
                this.search_input_number.value = this.keyword;
                this.search_input_number.focus();
            }
            else {
                this.search_input.value = this.keyword;
                this.search_input.focus();
            }

            this.hide();
            this.container.style.display = "block";
            this.item_menu.style.display = "block";
        }

        clear() {
            //clear home buttons
            this.item_suggestion_container.innerHTML = "";
            this.container.style.display = "none";
        }

        searchTypes: SP.ItemType[] = null; 

        async open(customerId: string, keyword: string, numberInput: boolean, callback: (itemInfo: SP.ItemInfo, extraData: ItemSearchExtraData) => void, types: SP.ItemType[] = null) {
            this.searchTypes = types;
            this.customerId = customerId;
            this.callback = callback;
            this.search_input.value = "";
            this.search_input_number.value = "";
            this.item_suggestion_container.innerHTML = "";
            this.keyword = keyword;
            this.numberInput = numberInput;

            if (customerId) await this.open_product_picker();
            else await this.open_customer_picker();

        }

        async search(keyword: string, autoPick: boolean) {
            var items = await SP.Data.Item.searchItemInfos(keyword, this.customerId, 50, this.searchTypes);
            this.resultCount = items.length;
            if (autoPick && items.length == 1) {
                if (this.callback) this.callback(items[0], new ItemSearchExtraData());
                return true;
            }

            this.item_suggestion_container.innerHTML = "";

            for (let i = 0; i < items.length; i++) {
                await this.addItem(items[i], new ItemSearchExtraData());
            }

            //highlight keywords
            keyword.split(" ").forEach(w => { SP.highlight(".item_suggestion_container", w); });

            return false;
        }

        close() {
            this.clear();
            this.container.style.display = "none";
        }

        addCustomer(item: SP.CustomerInfo) {
            var c = this.customer_suggestion_container.appendChild(document.createElement("div"))
            c.classList.add("btn", "noselect");
            c.innerHTML = `<div class='action'>${item.customerName}</div>`;
            c.addEventListener("click", () => {
                console.log("Picking customer ", item);
                this.customerId = item.customerId;
                this.open_product_picker();
            });
        }

        addItem(item: SP.ItemInfo, data: ItemSearchExtraData) {
            var c = this.item_suggestion_container.appendChild(document.createElement("div"))
            c.classList.add("btn", "noselect", "item");


            let incommingLabel = item.incommingCombined <= 0 ? "" : `<span class="label badge">${SP.Localize("word_incomming")}<br /><span>${item.incommingCombined}</span></span>`;
            let soldLabel = item.reservedCombined <= 0 ? "" : `<span class="label badge">${SP.Localize("word_sold")}<br /><span>${item.reservedCombined}</span></span>`;

            c.innerHTML = `
                <div class='image'><img src="${item.imageUrl}"></div>
                <div class="text">
                    <div class="sku">${item.sku}</div>
                    <div class="description">${item.description}</div>
                    <div class="barcode">${item.barcodes}</div>
                </div>
                <div class="labels">${incommingLabel} ${soldLabel}</div>
            `;

            c.addEventListener("click", () => {
                if (this.callback) this.callback(item, data);
                this.close();
            });

            return c;
        }
    }

}